import React from 'react';

const TableOfContents = ({ navItems }) => (
  <ul className="single-article__toc-menu">
    {navItems.map(({ url, title }) => (
      <li key={url}>
        <a href={url}>{title}&nbsp;></a>
      </li>
    ))}
  </ul>
);

export default TableOfContents;
